import React, {useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {LoadingSpinner} from "../LoadingSpinner";
import {ACCESS_TOKEN_KEY, SYSTEM_ID} from "../../constants/constants";
import OpsToast from "../../ops-library/ops-toast";

const AdminInformations = ({sectionId, webDatas, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [webData, setWebData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [infoChange, setInfoChange] = useState(false);

    const [description, setDescription] = useState(webDatas?.description ?? null);
    const [contactName, setContactName] = useState(webDatas?.contactName ?? null);
    const [street, setStreet] = useState(webDatas?.street ?? null);
    const [streetNr, setStreetNr] = useState(webDatas?.streetNr ?? null);
    const [postalCode, setPostalCode] = useState(webDatas?.postalCode ?? null);
    const [city, setCity] = useState(webDatas?.city ?? null);
    const [officialName, setOfficialName] = useState(webDatas?.officalName ?? null);
    const [ico, setIco] = useState(webDatas?.ico ?? null);
    const [dic, setDic] = useState(webDatas?.dic ?? null);
    const [icDph, setIcDph] = useState(webDatas?.icDph ?? null);
    const [iban, setIban] = useState(webDatas?.iban ?? null);
    const [phoneNumber, setPhoneNumber] = useState(webDatas?.phoneNumber ?? null);
    const [emailAddress, setEmailAddress] = useState(webDatas?.emailAddress ?? null);
    const [igUrl, setIgUrl] = useState(webDatas?.igUrl ?? null);
    const [ytUrl, setYtUrl] = useState(webDatas?.ytUrl ?? null);
    const [fbUrl, setFbUrl] = useState(webDatas?.fbUrl ?? null);

    useEffect(() => {
        getWebData();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getWebData() {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/webdata`,
        };

        axios(configuration)
            .then((result) => {
                setWebData(result.data.content)
                setLoading(false)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function patchWebData() {
        setLoading(true)
        const data = {
            description: description,
            contactName: contactName,
            street: street,
            streetNr: streetNr,
            postalCode: postalCode,
            city: city,
            officialName: officialName,
            ico: ico,
            dic: dic,
            icDph: icDph,
            iban: iban,
            phoneNumber: phoneNumber,
            emailAddress: emailAddress,
            igUrl: igUrl,
            ytUrl: ytUrl,
            fbUrl: fbUrl
        }
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/webdata/${SYSTEM_ID}`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setWebData(result.data.content)
                    setInfoChange(false)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="ADMINISTRÁCIA"/>
            {webData !== null ?
                <div>
                    {/* UVODNY POPIS */}
                    <div className="adm-container fa-flex-col">
                        <div className="desktop-row-phone-col justify-content-between align-items-center">
                            <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                                     content="Úvodný popis"/>
                            {hasRoleAccess(sectionId, user.role) && infoChange &&
                                <div className="fa-flex-row mt-2 gap-3">
                                    <OpsText type="label" color="color-red" alignment="left"
                                             content="Nezabudnite svoje zmeny uložiť!"/>
                                    <OpsBtn
                                        text="Uložiť"
                                        variant="primary"
                                        size="sm"
                                        textSize="md"
                                        action={() => patchWebData()}
                                    />
                                </div>
                            }
                        </div>
                        <div className="adm-content fa-w-100">
                            {/* DESCRIPTION */}
                            <div className="fa-flex-col fa-w-80 gap-1 me-5 mb-2">
                                <OpsInput id="official-name" size="bg"
                                          placeholder="Lorem ipsum..."
                                          customType="textarea"
                                          value={description}
                                          onChange={(e) => {
                                              setDescription(e.target.value)
                                              setInfoChange(true)
                                          }}
                                />
                            </div>
                        </div>
                    </div>
                    {/* KONTAKTNE UDAJE */}
                    <div className="adm-container fa-flex-col">
                        <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                                 content="Kontaktné údaje"/>

                        <div className="desktop-row-tablet-phone-col align-items-start gap-3">
                            <div className="adm-content fa-w-100">
                                {/* CONTACT NAME */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Kontaktná osoba"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="Meno a priezvisko"
                                              value={contactName}
                                              onChange={(e) => {
                                                  setContactName(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* EMAIL */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Emailová adresa"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="napr. email@gmail.com"
                                              value={emailAddress}
                                              onChange={(e) => {
                                                  setEmailAddress(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* PHONE */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Tel. číslo"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="napr. +421 915 456 871"
                                              value={phoneNumber}
                                              onChange={(e) => {
                                                  setPhoneNumber(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* STREET + STREET NR */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Ulica"/>
                                    <OpsInput id="street"
                                              placeholder="napr. Stredisková"
                                              value={street}
                                              onChange={(e) => {
                                                  setStreet(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Číslo"/>
                                    <OpsInput id="street-nr"
                                              placeholder="napr. 32"
                                              value={streetNr}
                                              onChange={(e) => {
                                                  setStreetNr(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* CITY */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Mesto"/>
                                    <OpsInput id="city" size="bg"
                                              placeholder="Napr. Košice"
                                              value={city}
                                              onChange={(e) => {
                                                  setCity(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* PSC */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="PSČ"/>
                                    <OpsInput id="psc" size="bg"
                                              placeholder="Napr. 04001"
                                              value={postalCode}
                                              onChange={(e) => {
                                                  setPostalCode(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                            </div>
                            <div className="adm-content fa-w-100">
                                {/* IG */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Instagram"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="napr. https://www.instagram.com/lh_betarky/"
                                              value={igUrl}
                                              onChange={(e) => {
                                                  setIgUrl(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* FB */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Facebook"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="napr. https://www.facebook.com/profile.php"
                                              value={fbUrl}
                                              onChange={(e) => {
                                                  setFbUrl(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* YT */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Youtube"/>
                                    <OpsInput id="official-name" size="bg"
                                              placeholder="napr. https://www.youtube.com/@ludovahudbabetarky"
                                              value={ytUrl}
                                              onChange={(e) => {
                                                  setYtUrl(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*DALSIE UDAJE*/}
                    <div className="adm-container fa-flex-col">
                        <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                                 content="Ďalšie údaje (zatiaľ nikde nepoužívané)"/>

                        <div className="desktop-row-tablet-phone-col align-items-start gap-3">
                            <div className="adm-content w-100">
                                {/* OFFICIAL NAME */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="Oficiálny názov"/>
                                    <OpsInput id="ico" size="bg"
                                              placeholder="Napr. Firma s.r.o."
                                              maxLength={10}
                                              value={officialName}
                                              onChange={(e) => {
                                                  setOfficialName(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* ICO */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="IČO"/>
                                    <OpsInput id="ico" size="bg"
                                              placeholder="Napr. 54276829"
                                              maxLength={10}
                                              value={ico}
                                              onChange={(e) => {
                                                  setIco(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* DIC */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="DIČ"/>
                                    <OpsInput id="dic" size="bg"
                                              placeholder="Napr. 1080804252"
                                              maxLength={10}
                                              value={dic}
                                              onChange={(e) => {
                                                  setDic(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* IC DPH */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="IČ DPH"/>
                                    <OpsInput id="icdph" size="bg"
                                              placeholder="Napr. SK1080804252"
                                              maxLength={12}
                                              value={icDph}
                                              onChange={(e) => {
                                                  setIcDph(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                                {/* IBAN */}
                                <div className="fa-flex-col gap-1 me-5 mb-2">
                                    <OpsText type="normal1" weight={600} color="primary-6" alignment="left"
                                             content="IBAN"/>
                                    <OpsInput id="iban" size="bg"
                                              placeholder="Napr. SK69 0200 0000 0037 5295 6156"
                                              value={iban}
                                              onChange={(e) => {
                                                  setIban(e.target.value)
                                                  setInfoChange(true)
                                              }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="py-5">
                    <LoadingSpinner/>
                </div>
            }
        </div>
    );
}

export default AdminInformations;